import cs from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { ComponentType, FC } from 'react';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import { LINKS } from '@/Module/Core/Constant';
import { IconHomeActive, IconHomeUsual, IconLearningActive, IconLearningUsual, IconProfileActive, IconProfileUsual, IconSearchActive, IconSearchUsual, IconSubscriptionActive, IconSubscriptionUsual, IconWorkspaceActive, IconWorkspaceDeActive } from '@/Module/Icon';
import type { IIconProps } from '@/Module/Icon/Model';
import { useAppSelector } from '@/Module/Store/Hook';
interface MenuItem {
  title: string;
  iconUsual: ComponentType<IIconProps>;
  iconActive: ComponentType<IIconProps>;
  link: string;
}
const beforeData: MenuItem[] = [{
  iconUsual: IconHomeUsual,
  iconActive: IconHomeActive,
  link: LINKS.HOME,
  title: 'خانه'
}, {
  iconUsual: IconLearningUsual,
  iconActive: IconLearningActive,
  link: LINKS.LEARNING,
  title: 'یادگیری'
}, {
  iconUsual: IconSearchUsual,
  iconActive: IconSearchActive,
  link: LINKS.DISCOVER,
  title: 'جستجو'
}, {
  iconUsual: IconSubscriptionUsual,
  iconActive: IconSubscriptionActive,
  link: LINKS.SUBSCRIPTION.MAIN,
  title: 'اشتراک'
}, {
  iconUsual: IconProfileUsual,
  iconActive: IconProfileActive,
  link: LINKS.AUTH.LOGIN,
  title: 'ورود'
}];
const afterData: MenuItem[] = [{
  iconUsual: IconWorkspaceDeActive,
  iconActive: IconWorkspaceActive,
  link: LINKS.WORKSPACE.MAIN,
  title: 'میزکار'
}, {
  iconUsual: IconLearningUsual,
  iconActive: IconLearningActive,
  link: LINKS.LEARNING,
  title: 'یادگیری'
}, {
  iconUsual: IconSearchUsual,
  iconActive: IconSearchActive,
  link: LINKS.DISCOVER,
  title: 'جستجو'
}, {
  iconUsual: IconSubscriptionUsual,
  iconActive: IconSubscriptionActive,
  link: LINKS.PROFILE.SUBSCRIPTION,
  title: 'اشتراک'
}, {
  iconUsual: IconProfileUsual,
  iconActive: IconProfileActive,
  link: LINKS.PROFILE.DEFAULT,
  title: 'آی‌نـوی من'
}];
const MobileFixedMenu: FC = () => {
  const isLogin = useAppSelector(state => state.auth.isLoggedIn);
  const data = isLogin ? afterData : beforeData;
  const router = useRouter();
  const isLandscape = useIsLandscape();
  return <nav className={cs(isLandscape ? 'w-[74px] flex-col border-l-2 z-[198] h-[calc(100vh-62px)] px-1 items-center justify-evenly top-[62px]' : 'w-full border-t-2 flex-row justify-around  px-4', 'fixed bottom-0 z-30 flex border-blackSix bg-white  py-[4px]')} data-sentry-component="MobileFixedMenu" data-sentry-source-file="MobileFixedMenu.tsx">
      {data.map(item => {
      const isActive = `${router.pathname}/` === item.link;
      return <Link className={cs('group relative flex flex-col items-center justify-center rounded-lg w-full max-w-[65px] h-[50px] text-sm', isActive ? 'text-primary' : 'text-blueSix hover:text-primary-hover', 'before:absolute before:bottom-0 before:left-0 before:right-0 before:h-0.5 before:bg-primary', isActive && 'before:scale-x-100', !isActive && 'before:scale-x-0 hover:before:scale-x-100', 'before:transition-transform before:duration-300 before:ease-in-out')} href={item.link} key={item.title} onClick={e => {
        if (`${router.pathname}/` === item.link) {
          e.preventDefault();
        }
      }}>
            {isActive ? <item.iconActive size="small" /> : <item.iconUsual size="small" />}
            <div className="mt-1 text-[13px] font-bold">{item.title}</div>
          </Link>;
    })}
    </nav>;
};
export default MobileFixedMenu;